(function () {
  'use strict';
  if (window.__lynkRhodeV30Loaded) return;
  window.__lynkRhodeV30Loaded = true;
  const active = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let suspended = false;
  function mount(root) {
    if (active.has(root) || suspended) return;
    const controller = new AbortController();
    const signal = controller.signal;
    let frame = 0;
    let observer;
    const gallery = root.querySelector('[data-rhode-gallery]');
    const track = gallery?.querySelector('[data-rhode-gallery-track]');
    let data;
    try { data = JSON.parse(gallery?.querySelector('[data-rhode-variants]')?.textContent || '{}'); } catch (_) { data = {}; }
    const on = (node, event, fn, options = {}) => node?.addEventListener(event, fn, { ...options, signal });
    function railState(section) {
      const rail = section.querySelector('[data-rhode-rail-track]');
      if (!rail) return;
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      section.querySelectorAll('[data-rhode-rail]').forEach(button => {
        button.disabled = button.dataset.rhodeRail === 'previous' ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
      });
    }
    root.querySelectorAll('.rhode-shop').forEach(section => {
      const rail = section.querySelector('[data-rhode-rail-track]');
      on(rail, 'scroll', () => railState(section), { passive: true });
      railState(section);
    });
    function galleryState() {
      if (!track || !track.clientWidth) return;
      const total = track.children.length;
      gallery.dataset.rhodeGallerySingle = String(total === 1);
      track.tabIndex = total > 1 ? 0 : -1;
      const current = Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      track.style.height = `${track.children[current].offsetHeight}px`;
      const bar = gallery.querySelector('[data-rhode-gallery-progress]');
      if (bar) { bar.style.width = `${100 / total}%`; bar.style.transform = `translateX(${100 * current}%)`; }
      const status = gallery.querySelector('[data-rhode-gallery-status]');
      if (status) {
        const text = `${current + 1} / ${total}`;
        const label = String(data.status || '').replaceAll('__CURRENT__', String(current + 1)).replaceAll('__TOTAL__', String(total));
        if (status.textContent !== text) status.textContent = text;
        if (status.getAttribute('aria-label') !== label) status.setAttribute('aria-label', label);
      }
      gallery.querySelectorAll('[data-rhode-gallery-step]').forEach(button => { button.disabled = Number(button.dataset.rhodeGalleryStep) < 0 ? current === 0 : current >= total - 1; });
    }
    function galleryStep(step) {
      if (!track) return;
      track.scrollBy({ left: step * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
    }
    function selectedVariant() {
      if (!data.variants) return null;
      const picker = root.querySelector('variant-selects,variant-radios');
      const choices = picker ? Array.from(picker.querySelectorAll('.product-form__input')).map(group => group.querySelector('input[type="radio"]:checked')?.value || group.querySelector('select')?.value).filter(Boolean) : [];
      const id = root.querySelector('product-form[data-main="true"] input[name="id"]')?.value;
      return choices.length ? data.variants.find(variant => variant.options.length === choices.length && variant.options.every((value, index) => value === choices[index])) : data.variants.find(variant => String(variant.id) === String(id));
    }
    function sync() {
      frame = 0;
      if (!root.isConnected || suspended || !gallery) return;
      const variant = selectedVariant();
      if (!variant) return;
      const template = Array.from(gallery.querySelectorAll('template[data-rhode-variant]')).find(item => item.dataset.rhodeVariant === String(variant.id));
      if (!template) return;
      const studio = gallery.querySelector('[data-rhode-studio]');
      if (studio && studio.dataset.selectedVariant !== String(variant.id)) {
        const fragment = template.content.querySelector('[data-rhode-template-studio]');
        if (fragment) studio.replaceChildren(...Array.from(fragment.childNodes).map(node => node.cloneNode(true)));
        studio.dataset.selectedVariant = String(variant.id);
        track?.scrollTo({ left: 0, behavior: 'auto' });
      }
      const scent = template.content.querySelector('[data-rhode-template-scent]')?.textContent || variant.title;
      const notes = template.content.querySelector('[data-rhode-template-notes]')?.textContent.trim() || '';
      const story = template.content.querySelector('[data-rhode-template-story]')?.textContent.trim() || '';
      root.querySelectorAll('[data-rhode-selected-story]').forEach(node => { if (node.textContent !== story) node.textContent = story; });
      root.querySelectorAll('[data-rhode-selected-scent]').forEach(node => { if (node.textContent !== scent) node.textContent = scent; });
      root.querySelectorAll('[data-rhode-scent-variant]').forEach(node => { if (node.dataset.rhodeScentVariant === String(variant.id)) node.setAttribute('aria-current', 'true'); else node.removeAttribute('aria-current'); });
      root.querySelectorAll('[data-rhode-selected-notes]').forEach(node => { if (node.textContent !== notes) node.textContent = notes; node.hidden = !notes; });
      root.querySelectorAll('[data-rhode-notes-row]').forEach(node => { node.hidden = !notes; });
      galleryState();
    }
    function queueSync() { if (!frame && !suspended) frame = requestAnimationFrame(sync); }
    on(root, 'click', event => {
      const button = event.target.closest('[data-rhode-rail]');
      if (button) {
        const rail = button.closest('.rhode-shop')?.querySelector('[data-rhode-rail-track]');
        rail?.scrollBy({ left: (button.dataset.rhodeRail === 'previous' ? -1 : 1) * rail.clientWidth * .85, behavior: reduced.matches ? 'auto' : 'smooth' });
      }
      const step = event.target.closest('[data-rhode-gallery-step]');
      if (step) galleryStep(Number(step.dataset.rhodeGalleryStep));
      const packagingLink = event.target.closest('[data-rhode-packaging-link]');
      if (packagingLink) {
        const target = document.getElementById(packagingLink.getAttribute('href').slice(1));
        if (target?.tagName === 'DETAILS') target.open = true;
      }
    });
    on(track, 'scroll', galleryState, { passive: true });
    on(track, 'keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); galleryStep(event.key === 'ArrowLeft' ? -1 : 1);
    });
    on(root, 'change', event => { if (event.target.closest('variant-selects,variant-radios,product-form')) queueSync(); });
    on(root, 'error', event => {
      const image = event.target;
      if (image.tagName !== 'IMG' || !image.hasAttribute('data-rhode-media-key')) return;
      const message = document.createElement('p');
      message.className = 'rhode-image-error';
      message.textContent = data.imageError || image.alt;
      message.setAttribute('role', 'status');
      image.replaceWith(message);
    }, { capture: true });
    on(window, 'resize', () => { root.querySelectorAll('.rhode-shop').forEach(railState); galleryState(); });
    on(window, 'popstate', queueSync);
    if (gallery) {
      observer = new MutationObserver(queueSync);
      const info = root.querySelector('product-info');
      if (info) observer.observe(info.parentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value'] });
    }
    root.dataset.rhodeEnhanced = 'true';
    galleryState(); sync();
    active.set(root, () => { controller.abort(); observer?.disconnect(); if (frame) cancelAnimationFrame(frame); delete root.dataset.rhodeEnhanced; });
  }
  function initialize() {
    for (const [root, dispose] of active) if (!root.isConnected) { dispose(); active.delete(root); }
    document.querySelectorAll('.lynk-rhode-v30,.lynk-product-rhode-v30').forEach(mount);
  }
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => { for (const [root, dispose] of active) if (event.target.contains(root)) { dispose(); active.delete(root); } });
  window.addEventListener('pagehide', () => { suspended = true; for (const dispose of active.values()) dispose(); active.clear(); });
  window.addEventListener('pageshow', () => { suspended = false; initialize(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
}());
